const overview_table = {
	cpu: "CPU cores",
	mem: "RAM memory",
	name: "Name",
	os_name: "Operating system",
	status: "Status",
};

export default overview_table;
